import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "form", "inquirable"]

  submitFilterForm() {
    this.formTarget.requestSubmit()
  }

  removeInquirableFilter(event) {
    const inquirableElement = this.inquirableTargets.find((element) => {
      return element.dataset.productId === String(event.params.productId)
    })

    if (inquirableElement) {
      inquirableElement.remove()
    }
  }
}
